import React, { useState, useEffect } from 'react';
import * as ReactGA from 'react-ga';

// Components
import { Button } from '../../components/Button';
import { Answer } from '../../components/Answers/Answer';
import { Layout } from '../../components/Layout';
import { Heading } from '../../components/Heading';

// i18n
import { useTranslation } from '../../translations/useTranslation';
import { useForm } from '../../context/form-context/hooks';
import {
  setFormScene,
  setGivenConsent,
} from '../../context/form-context/actions';

export const AlreadyMemberView: React.FC = () => {
  const { state, dispatch } = useForm();
  const [choice, setChoice] = useState<string>(() => {
    if (state.givenConsent === true) {
      return 'yes';
    } else if (state.givenConsent === false) {
      return 'no';
    } else {
      return '';
    }
  });
  const { t, m, keys, locale } = useTranslation();

  // useEffect(() => {
  //   if (state.union) {
  //     ReactGA.event({
  //       category: 'Medlemsansökan',
  //       action: `User was already a member of ${state.union}`,
  //       nonInteraction: true,
  //     });
  //   }
  // }, [state.union]);

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChoice(event.target.value);
  };

  const handleOnNext = () => {
    if (dispatch) {
      dispatch(setGivenConsent(choice === 'yes' ? true : false));
      dispatch(setFormScene('FORM'));
    }
  };

  const title = m(keys.alreadyMemberTitle, '{name}', state.union || '');
  const confirmLabel = m(keys.alreadyMemberYes, '{name}', state.union || '');
  const declineLabel = m(keys.alreadyMemberNo, '{name}', state.union || '');

  const myMembership =
    locale === 'en' ? (
      <span>
        Login to
        <a
          href="https://medlem.akademikernasakassa.se/"
          title="Mitt medlemskap"
        >
          "Mitt medlemskap"
        </a>{' '}
        to check or update your details.
      </span>
    ) : (
      <span>
        Logga in i{' '}
        <a
          href="https://medlem.akademikernasakassa.se/"
          title="Mitt medlemskap"
        >
          Mitt medlemskap
        </a>{' '}
        för att kontrollera eller ändra dina uppgifter.
      </span>
    );

  if (state.union === 'Akademikernas a-kassa') {
    return (
      <Layout viewId={'already-member'}>
        <div className="flex flex-column gap-2xs">
          <h1 className="text-2xl">
            {t(keys.headingGreeting)} {state.contactInfo?.firstName}
          </h1>
          <h2 className="font-primary letter-spacing-reset text-md">
            {t(keys.alreadyAEAMember)}
          </h2>
          <div className='text-component'>
            <p>{myMembership}</p>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout viewId={'already-member'}>
      <div className="flex flex-column gap-2xs">
        <h1 className="text-2xl">
          {t(keys.headingGreeting)} {state.contactInfo?.firstName}
        </h1>
        <h2 className="font-primary letter-spacing-reset text-md">{title}</h2>

        <div className="flex flex-column gap-3xs">
          <Answer
            type={'radio'}
            name={'giveConsent'}
            label={confirmLabel}
            radioButtonValue={'yes'}
            value={choice}
            onChange={handleOnChange}
          />
          <Answer
            type={'radio'}
            name={'giveConsent'}
            label={declineLabel}
            radioButtonValue={'no'}
            value={choice}
            onChange={handleOnChange}
          />
        </div>
      </div>
      <Button
        className="margin-top-2xs"
        title={t(keys.uiButtonNext)}
        onClick={handleOnNext}
        disabled={choice === ''}
      />
    </Layout>
  );
};
